import React from 'react';
import PaddleHeader from '../components/header/PaddleHeader';

interface IProps {
    children: React.ReactNode;
}

const PaddleHeaderLayout = ({ children }: IProps) => {
    return (
        <div className="tw-w-screen tw-h-screen tw-flex tw-flex-col">
            <PaddleHeader />

            <div className="tw-flex-1 tw-flex tw-pt-12 tw-h-screen">
                <div className="tw-flex-1 tw-overflow-y-auto tw-h-full tw-pb-5">{children}</div>
            </div>
        </div>
    );
};

export default PaddleHeaderLayout;
